import { Button, Flex, GmgTheme } from '@gmg/gmg-react-components';
import { FunctionComponent, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import AppContext from 'src/AppContext';
import styled, { useTheme } from 'styled-components';
import { getContactSupportEvent } from 'src/tracking';
import { Link } from 'react-router-dom';
import PageNotFoundImgDark from '../../assets/svg/graphic_magnifier-dark-255.svg';
import PageNotFoundImgLight from '../../assets/svg/graphic_magnifier-light-255.svg';

interface EmptyModuleListProps { };

const EmptyModuleList: FunctionComponent<EmptyModuleListProps> = (props) => {
    const { t } = useTranslation();
    const { trackEvent } = useContext(AppContext);
    const theme: GmgTheme = useTheme();

    const noProductsMsg = t('UserProfile.no_products_msg', "You currently have no GMG products assigned to your account. This might mean your organization admin hasn't set up product access for you yet. Please contact your organization admin. You can also reach out to our Support Team for assistance.");

    return (
        <Container>
            <Header>
                <h3 className="px12_400_normal" aria-label="My Apps Navigation Title">
                    {t('UserProfile.table_title', 'My Apps')}
                </h3>
            </Header>
            <Flex flexDirection='column' gap='16px' width='100%' height='100%' justifyContent='center' alignItems='center'>
                {theme.type === 'dark'
                    ? <PageNotFoundImgDark width={255} height={255} />
                    : <PageNotFoundImgLight width={255} height={255} />
                }
                <Message className='px14_400_contrast'>
                    {noProductsMsg}
                </Message>
                <NonDecoratedLink
                    to='https://gmgcolor.com/support'
                    target='_blank'
                    rel='noopener noreferrer'
                    aria-label='Contact our Support Team'
                    onClick={() => { trackEvent(getContactSupportEvent()); }}
                >
                    <Button variant='primary' size='big' className='px12_400_normal'>
                        {t('UserProfile.contact_support_button', 'Contact Support')}
                    </Button>
                </NonDecoratedLink>
            </Flex>
        </Container>
    );
};

const Header = styled.div`
    border-bottom: 1px solid ${props => props.theme.colors.backgroundPaper};
    margin: 16px 16px 0px 16px;
    padding: 0 0 16px 0;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: calc(80vh); //fallback for browsers that don't support dvh
    min-height: calc(80dvh);
    background-color: ${props => props.theme.colors.background};
`;

const Message = styled.p`
    display: flex;
    text-align: center;
    line-height: 1.6;
    width: 80%;
`;

const NonDecoratedLink = styled(Link)`
    text-decoration: none;
    padding-bottom: 16px;
`;

export default EmptyModuleList;